import { fetchDataElementData } from "../../helpers/data-catalogue-api"

const modal = document.getElementById("dataElementModal")
const closeBtn = document.getElementById("closeModalBtn")
const modalTitle = document.getElementById("modalTitle")
const modalDescription = document.getElementById("modalDescription")
const modalType = document.getElementById("modalType")
const detailsPanel = document.getElementById("mobileDetailsPanel")
const factorsPanel = document.getElementById("mobileFactorsPanel")
const paneSelector = document.getElementById("mobileModalPaneSelector")

function updateDetailsPane(card) {
    const name = card.querySelector("[data-name]")?.dataset.name || ""

    const description = card.querySelector("[data-description]")?.dataset.description || ""
    const dataType = card.querySelector("[data-type]")?.dataset.type || ""

    modalTitle.textContent = name || ""

    if (dataType) {
        modalType.innerHTML =
            '<button class="btn btn--tag min-w-max cursor-pointer pointer-events-none bg-transparent font-roboto">' +
            dataType +
            "</button>"
    }

    if (description) {
        modalDescription.textContent = description
        modalDescription.style.display = "block"
    } else {
        modalDescription.style.display = "none"
    }
}

function updateFactorsPane(variableData) {
    if (!variableData?.dataType?.enumerations || variableData.dataType.enumerations.length === 0)
        return

    const enumerations = variableData.dataType.enumerations.map((enumValue) =>
        generateFactorsItem(enumValue.name, enumValue.description)
    )

    factorsPanel.innerHTML = enumerations.join("")
}

function generateFactorsItem(name, description) {
    return `<div class="space-y-4 py-4 first:pt-0 text-base">
            <p>Value<span class="pl-6">${name}</span></p>
            <p>${description}</p>
            <div class="border-b border-b-[#B9B9B9]"></div>
        </div>`
}

async function openModal(btn) {
    const params = new URLSearchParams(window.location.search)
    const originId = params.get("originId")
    const dataElementId = btn.dataset.elementId
    const card = document.getElementById(dataElementId)

    if (!dataElementId || !originId) {
        console.error("Missing data element ID or origin ID")
        return
    }

    updateDetailsPane(card)

    document.body.style.overflow = "hidden"

    modal.showModal()

    if (closeBtn) {
        closeBtn.focus()
    }

    // Fetch data from API
    try {
        const data = await fetchDataElementData(dataElementId, originId)
        updateFactorsPane(data)
    } catch (error) {
        console.error("Error fetching data element details:", error)
    }
}

function closeModal() {
    modal.close()

    document.body.style.overflow = ""

    modalTitle.innerHTML = ""
    modalDescription.innerHTML = ""
    modalType.innerHTML = ""
    factorsPanel.innerHTML = ""
    paneSelector.value = "details"
    detailsPanel.classList.remove("hidden")
    factorsPanel.classList.add("hidden")
}

function addPanesEvents() {
    paneSelector.addEventListener("change", () => {
        if (paneSelector.value === "details") {
            detailsPanel.classList.remove("hidden")
            factorsPanel.classList.add("hidden")
        } else {
            detailsPanel.classList.add("hidden")
            factorsPanel.classList.remove("hidden")
        }
    })
}

export function initializeDataDictionaryModal() {
    if (!modal) return

    const openModalBtns = document.querySelectorAll(".js-open-modal")

    // Add click event to all "View details" buttons
    openModalBtns.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault()
            openModal(btn)
        })
    })

    if (closeBtn) {
        closeBtn.addEventListener("click", closeModal)
    }

    addPanesEvents()
}
